import React from 'react';
import { AppConfirmModal } from '../ui';

const CronConfirmModal = ({
  show,
  title,
  children,
  confirmLabel = 'Confirmer',
  confirmIcon = 'mdi:check',
  confirmVariant = 'primary',
  busy = false,
  onConfirm,
  onCancel,
}) => (
  <AppConfirmModal
    show={show}
    title={title}
    confirmLabel={confirmLabel}
    confirmIcon={confirmIcon}
    confirmVariant={confirmVariant === 'danger' ? 'danger' : 'primary'}
    saving={busy}
    onConfirm={onConfirm}
    onClose={onCancel}
    className="kkp-crons-modal"
  >
    {children}
  </AppConfirmModal>
);

export default CronConfirmModal;
